export type IHook = (params: { email?: string }) => {
  isValid: boolean;
  errorMessage?: string;
};

export enum EmailErrors {
  INVALID = "errors.email.invalid",
}
